import { render, staticRenderFns } from "./StudentScholarshipHorizontalBarChart.vue?vue&type=template&id=6f23d19c&"
import script from "./StudentScholarshipHorizontalBarChart.vue?vue&type=script&lang=js&"
export * from "./StudentScholarshipHorizontalBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports